import { PuntoInspeccionViewModel } from 'src/app/components/_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { TMedioTransporteViewModel, TcTipoSolicitudViewModel, TwSolicitudJerarquiaViewModel } from '../datosbasicos/datosbasicos.types';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { TComentarioInspectorViewModel } from '../seguimiento/seguimiento.types';
import { ConfiguracionImportadorLugarDestinoSolicitudViewModel } from '../importador-lugardestino/importador-lugardestino.types';

export class SolicitudProductosViewModel {
    constructor() {}

    public Id: number;
    public IdEstadoSolicitud = 0;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public IdTipoSolicitud = 0;
    public IdEstadoChedPp: number | null;
    public IdSubTipoSolicitud: number | null = null;
    public IdPais: number | null = null;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public IsCanariasPifCanarias = false;
    public CodigoSolicitud: string;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPpDescripcion: string;
    public CodigoTipoSolicitud: string;
    public FechaLlegada: Date;
    //public TieneDocumentoCoi: boolean;//RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
    public TProductoSolicitudCollection: TProductoSolicitudViewModel[];
    public TSolicitudEquipamientoCollection: EquipamientoViewModel[];
    public TPuntoInspeccion: PuntoInspeccionViewModel;
    public TComentarioInspectorCollection: TComentarioInspectorViewModel[];
    public TMedioTransporte: TMedioTransporteViewModel;
    public TcTipoSolicitud: TcTipoSolicitudViewModel;
    public TcEstadoSolicitud: Tc;
    public TwEmbalajesCollection: TwEmbalajesViewModel[];
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
}

export class TwEmbalajesViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdTaric: number;
    public IdTaricEmbalajeDescripcion: string;
    public IdEppo: number;
    public IdEppoEmbalajeDescripcion: string;
    public IdUnidad: number;
    public IdUnidadEmbalajeDescripcion: string;
    public IdPais: number;
    public IdPaisEmbalajeDescripcion: string;
    public IdPaisReImportacion: number | null;
    public Recuento: number;
    public IdSubTipoSolicitud: number;
    public IdEstadoSolicitud: number;
    public IdEstadoChedPp: number | null;
    public Codigo: string;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoSolicitudDescripcion: string;
    public IdEstadoChedPpDescripcion: string;
    public CodigoTipoSolicitud: string;
    public MuestraLaboratorio: boolean;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    //campo para uso interno en Rechazos Parciales
    public Aceptado: boolean | null = null;
    public DeRechazoParcial: boolean;
}

export class TProductoSolicitudViewModel {
    public Id: number;
    public IdSolicitud: number;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public IdEspecie: number;
    public IdBotanicaDescripcion: string;
    public IdPais: number;
    public IdPaisDescripcion: string;
    public NombreComun: string;
    public IdTaricProductoNombreComun: string;
    public IdTaricProductoNombreCientificoNombreComun: string;
    public IdGrupo: number;
    //public IdGrupoDescripcion: string;
    public IdForma: number;
    public IdFormaDescripcion: string;
    public EspecieSinEppo: boolean;
    public MarcasBulto: string;
    public NumeroBulto: number | null;
    //RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
    //public EsOrganico: boolean;
    //public TieneDocumentoCoi: boolean;
    public Peso: number;
    public Volumen: number | null;
    public Nrc: string;
    public IdEnvioAduanas: number;
    public IdEnvioAduanasDescripcion: string;
    public Unidades: number | null;
    public IdTipoBulto: number | null;
    public IdPaisReImportacion: number | null;
    public DeclaracionSumaria: string;
    public Mrn: string;
    public IdEnvioFisico: number;
    public Partida: string;
    public IsLevante: boolean;
    public ConCorteza: boolean;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoSolicitudDescripcion: string;
    public CodigoTipoSolicitud: string;
    //para grid predua
    public Grupo: string;
    public IdTipoSolicitud: number;
    public IdSubTipoSolicitud: number;
    public IdEstadoSolicitud: number;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public Codigo: string;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public MuestraLaboratorio: boolean;
    public EsDeCfCanarias: boolean;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    //campo para uso interno en Rechazos Parciales
    public Aceptado: boolean | null = null;
    public DeRechazoParcial: boolean;
    public IsCanariasPifCanarias = false;
    public IdConfiguracion: number | null;
    public TwTcConfiguracionImportadorYlugarDestinoPorSolicitud: ConfiguracionImportadorLugarDestinoSolicitudViewModel;
}

export class EquipamientoViewModel {
    public Id: number;
    public IdSolicitud: number;
    public Matricula: string;
    public Inspeccion: boolean;
}

export const COOKIE_CONFIG_INCOMPATIBLE_NAME = 'IDSolicitudConfigIncompatible';

export class ComprobarCompatibleViewModel {
    public IdSolicitud: number;
    public CodigoTaric: string;
    public idConfiguracion: number;
}

//export class SolicitudEquipamientoViewModel {

//    public Id: number;
//    public IdEstadoSolicitud: number = 0;
//    public FechaCreacion: Date;
//    public TTasaCollection: TTasaViewModel[];
//}
